const pdpAccordions = document.querySelectorAll('[data-accordion]');

function duplicateClassAsIDs() {
  pdpAccordions.forEach((pdpAccordion) => {
    const contentClassNames = pdpAccordion.querySelectorAll('ul');

    contentClassNames.forEach((contentClassName) => {
      if (!contentClassName) return;

      const btn = contentClassName.querySelector('[data-accordion-btn]');
      if (!btn) return;
      
      const classname = contentClassName.getAttribute('class');
      btn.setAttribute('aria-controls', classname);
      contentClassName.setAttribute('id', classname);
    });
  });
}

function initAccordion() {
  pdpAccordions.forEach((pdpAccordion) => {
    const buttons = pdpAccordion.querySelectorAll('[data-accordion-btn]');

    function closeAccordion(element, content) {
      element.classList.remove('active');
      element.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.visibility = 'hidden';
    }

    function openAccordion(element, content) {
      content.style.visibility = 'visible';
      element.classList.add('active');
      element.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    }

    if (buttons.length > 0) {
      const allContent = pdpAccordion.querySelectorAll('[data-accordion-content]');
      allContent.forEach((content) => {
        content.style.visibility = 'hidden';
      });

      buttons.forEach((button) => {
        if (!button) return;

        button.addEventListener('click', (e) => {
          e.preventDefault();

          const target = e.target.closest('div');
          const content = target.querySelector('[data-accordion-content]');
          target.classList.contains('active')
            ? closeAccordion(target, content)
            : openAccordion(target, content);
        });
      });
    }
  });
}

window.addEventListener('load', duplicateClassAsIDs);
window.addEventListener('load', initAccordion);